module.exports = __webpack_public_path__ + "static/media/yunying3.8671f6cf.jpg";